import dayjs from 'dayjs';
import Text from '../../../../components/detail/components/Text.component';
import { Chip, Paper } from '@mui/material';
import _ from 'lodash';
import {
  OperationTypes,
  StatusLogbookDeliveries,
} from '../../../logbook/conf/Data.conf';
import RectangleChip from '../../../../components/common/RectangleChip.component';
import { defaultChipColor } from '../Data.conf';

export const DetailConf = {
  initialState: {
    loading: false,
    error: null,
    data: null,
    meta: null,
  },
  fields: [
    {
      type: 'text',
      label: '',
      key: 'attributes.operation_type',
      xs: 12,
      sm: 4,
      md: 4,
      lg: 3,
      xl: 1.5,
    },
    {
      type: 'text',
      label: '',
      key: 'attributes.status_logbook',
      xs: 12,
      sm: 4,
      md: 4,
      lg: 3,
      xl: 1.5,
    },
    {
      type: 'text',
      label: '',
      key: 'attributes.collection_delivery_date',
      xs: 12,
      sm: 4,
      md: 4,
      lg: 3,
      xl: 2,
    },
    {
      type: 'text',
      label: '',
      key: 'attributes.collection_delivery_time',
      xs: 12,
      sm: 4,
      md: 4,
      lg: 3,
      xl: 1,
    },
    {
      type: 'text',
      label: 'Supplier',
      key: 'attributes.id_supplier.data.attributes.company_name',
      xs: 12,
      sm: 4,
      md: 4,
      lg: 2,
      variant: 'subtitle2',
    },
    {
      type: 'text',
      label: '',
      key: 'attributes',
      xs: 12,
      sm: 4,
      md: 4,
      lg: 1.5,
    },
    {
      type: 'text',
      label: '',
      key: 'contactOnBoard',
      xs: 12,
      sm: 4,
      md: 4,
      lg: 3,
      xl: 2,
    },
    {
      type: 'text',
      label: '',
      key: 'attributes.delivery_notes',
      xs: 12,
    },
  ],
  formatValue: (key, value) => {
    switch (key) {
      case 'attributes.operation_type':
        return (
          <RectangleChip
            value={value || '-'}
            size='small'
            sx={{
              borderRadius: 1,
              boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
              backgroundColor: _.find(
                OperationTypes,
                (item) => item.id === value
              )?.backgroundColor,
              color: _.includes(value, 'DELIVERY') && '#fff',
            }}
            fontSize='0.75rem'
            fontWeight={600}
            width={'auto'}
          />
        );
      case 'attributes.status_logbook':
        const statusInfo =
          StatusLogbookDeliveries.find((item) => item.id === value) ||
          defaultChipColor;
        return (
          <RectangleChip
            value={value || '-'}
            size='small'
            sx={{
              borderRadius: 1,
              boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
              backgroundColor: statusInfo?.backgroundColor,
              color: statusInfo?.color,
            }}
            fontSize='0.75rem'
            fontWeight={600}
            width={'auto'}
          />
        );
      case 'attributes.collection_delivery_date':
        return (
          <Text
            variant='subtitle2'
            label='Date'
            value={dayjs(value).format('DD-MM-YYYY')}
          />
        );
      case 'attributes.collection_delivery_time':
        return (
          <Text
            variant='subtitle2'
            label='Time'
            value={value ? dayjs(value, 'HH:mm:ss').format('HH:mm') : '-'}
          />
        );
      case 'attributes':
        const ORDER_PRV = 'PRV';
        const ORDER_INT = 'INT';
        return (
          <Text
            variant='subtitle2'
            label='N. Order'
            value={(() => {
              const shortDescription =
                value?.id_department?.data?.attributes?.short_description;
              const deliveryNoteNumber =
                value?.id_delivery_note?.data?.attributes
                  ?.delivery_note_number ??
                value?.id_list_items?.data?.[0]?.attributes?.id_list?.data
                  ?.attributes?.id_delivery_note?.data?.attributes
                  ?.delivery_note_number;

              return [ORDER_PRV, ORDER_INT].includes(shortDescription) &&
                deliveryNoteNumber ? (
                <Chip
                  size='small'
                  sx={{ mt: -0.5 }}
                  label={deliveryNoteNumber}
                />
              ) : (
                '-'
              );
            })()}
          />
        );
      case 'contactOnBoard':
        return (
          value?.attributes?.id_users_permissions_user?.data?.attributes
            ?.name && (
            <Text
              variant='subtitle2'
              label='Contact On Board'
              value={`${value?.attributes?.id_users_permissions_user?.data?.attributes?.name} ${value?.attributes?.id_users_permissions_user?.data?.attributes?.surname}`}
            />
          )
        );
      case 'attributes.delivery_notes':
        if (!value) return null;
        return (
          <Paper
            elevation={0}
            sx={{
              px: 1,
              mt: 1,
              width: '100%',
              background:
                'linear-gradient(135deg,rgb(255, 217, 159) 0%,rgb(253, 237, 185) 100%)',
              borderRadius: 1,
              border: '1px solid rgba(0,0,0,0.05)',
            }}
          >
            <Text variant='subtitle2' label='Notes' value={value} />
          </Paper>
        );
      default:
        return null;
    }
  },
};
